import React from "react";
import { Layout, Row, Col, Typography, Card } from "antd";
import { Routes } from "routes";
import { withRouter, RouteComponentProps } from "react-router-dom";

import NavBar from "components/nav-bar";
import { getElementByClassName } from 'utils/dom-utils';

import "./solution.less";
import hero from "assets/hero.png";
import heroPortrait from "assets/hero_portrait.png";
import pattern from "assets/pattern.svg";
import homeData from 'data/home.json';
import solutionData from 'data/solution.json';
import { FooterBar } from "components/footer";

class Solution extends React.Component<RouteComponentProps> {
  render() {
    return (
      <Layout className='page--solution'>
        <Row align='middle' justify='center' className='landing__container'>
          <Col xs={0} sm={0} md={24} lg={24} xl={24} xxl={24}
          className='landing__hero-image' style={{backgroundImage: `url(${hero})`}} />
          <Col xs={24} sm={24} md={0} lg={0} xl={0} xxl={0}
          className='landing__hero-image' style={{backgroundImage: `linear-gradient(rgba(255,255,255, 0.5), rgba(255, 255, 255, 0.5)), url(${heroPortrait})`}} />
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}></Col>
          <Col xs={22} sm={22} md={20} lg={18} xl={16} xxl={14}>
            <Typography.Title className='landing__product-name'>{homeData.platformName}</Typography.Title>
            <Col xs={24} sm={24} md={20} lg={18} xl={12} xxl={12}>
              <Typography.Title className='landing__title'>{homeData.platformMotto}</Typography.Title>
            </Col>
          </Col>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}></Col>
        </Row>
        <div className='landing_placeholder' />

        <Layout.Content className='content__container'>
          <NavBar className='landing__navbar' />

          <Row className='solution__container'>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to right, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>

          <Col xs={22} sm={22} md={20} lg={18} xl={16} xxl={14}>
            <Row>
              <Typography.Title className='content__title'>What we do</Typography.Title>
            </Row>

            <Row>
              <Typography.Title level={3} className='solution__headline'>{solutionData.headline}</Typography.Title>
            </Row>

            <Row>
              <Typography.Text className='solution__post-headline'>{solutionData.postHeadline}</Typography.Text>
            </Row>

            <Row>
              <Typography.Text className='solution__description'>{solutionData.description}</Typography.Text>
            </Row>

            <Row>
              <Typography.Title level={3} className='solution__goals'>{`Our Goals at ${homeData.platformName}`}</Typography.Title>
            </Row>

            <Row gutter={[20, 20]}>
              {this.goals}
            </Row>

          </Col>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to left, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>
          </Row>

          <FooterBar />
        </Layout.Content>
      </Layout>
    );
  }

  componentDidMount() {
    window.addEventListener('scroll', this.repositionNavBar);
    this.repositionNavBar();

    window.addEventListener('scroll', this.zoomHero);
    window.addEventListener('scroll', this.fadeTitle);

    this.scrollToSolution(1000);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.repositionNavBar);
    window.removeEventListener('scroll', this.zoomHero);
    window.removeEventListener('scroll', this.fadeTitle);
    window.scroll(0, 0);
  }

  componentDidUpdate() {
    this.scrollToSolution(200);
  }

  private repositionNavBar(): void {
    let top = getElementByClassName('content__container', 0).getBoundingClientRect().top;
    if(top <= 0) {
      top = 0;
    }
    getElementByClassName('landing__navbar', 0).style.top = top + 'px';
  }

  private zoomHero(): void {
    let scale = `scale(${1 + window.scrollY / 5500})`;
    getElementByClassName('landing__hero-image', 0).style.transform = scale;
    getElementByClassName('landing__hero-image', 1).style.transform = scale;
  }

  private fadeTitle(): void {
    let opacity = `${1 - window.scrollY / 1000}`;
    getElementByClassName('landing__product-name', 0).style.opacity = opacity;
    getElementByClassName('landing__title', 0).style.opacity = opacity;
  }

  private scrollToSolution(delay: number): void {
    if(this.props.history.location.pathname === Routes.SOLUTION) {
      setTimeout(() => {
        try {
          var top = getElementByClassName('content__container', 0).getBoundingClientRect().top;
        } catch(e) {
          // the user navigated to another page before the timeout could fire
          return;
        }
        window.scrollBy({
          top,
          left: 0,
          behavior : "smooth"
        });
      }, delay);
    }
  }

  private get goals(): JSX.Element[] {
    let goalCards: JSX.Element[] = [];
    for(let goal of solutionData.goals) {
      goalCards.push(
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} key={goal.title}>
          <Card className='goal__container'>
            <Row align='middle'>
              <Col>
                <img className='goal__illustration' src={require(`data/solution/${goal.image}`)} alt='' />
              </Col>
              <Col>
                <Typography.Title level={4} className='goal__name'>{goal.title}</Typography.Title>
              </Col>
            </Row>
            <Typography.Text className='goal__description'>{goal.description}</Typography.Text>
          </Card>
        </Col>
      );
    }
    return goalCards;
  }
}

export default withRouter(Solution);
